// redux/seasonSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedSeason: null,
};

const seasonSlice = createSlice({
  name: 'season',
  initialState,
  reducers: {
    setSelectedSeasonglobal: (state, action) => {
      state.selectedSeason = action.payload;
    },
    clearSelectedSeason: (state) => {
      state.selectedSeason = null;  
    }
  },
});

export const { setSelectedSeasonglobal, clearSelectedSeason } = seasonSlice.actions;
export default seasonSlice.reducer;
